// extracted by mini-css-extract-plugin
export default {"wrapper":"useModalDialog-module__wrapper___IS3gq","wrapperSm":"useModalDialog-module__wrapperSm___m8S8v"};